import { Component, inject } from '@angular/core';
import { ClientConfigService } from '../../services/client-config.service';
import { NgClass } from '@angular/common';

@Component({
    selector: 'app-maintenance-page',
    templateUrl: './maintenance-page.component.html',
    styleUrl: './maintenance-page.component.scss',
    imports: [NgClass]
})
export class MaintenancePageComponent {
  private clientConfigService = inject(ClientConfigService);

  brokerId = this.clientConfigService.getBrokerId();
  currentYear = new Date().getFullYear();
}
